import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'

export default class AppShowcase extends Component {
  render() {
    const {
      title,
      firstColumn,
      secondColumn,
      image,
      iosLink,
      androidLink
    } = this.props

    return (
      <Wrapper>
        <Container fluid style={{position: 'relative', zIndex: 1}}>
          <Row>
            <Col>
              <Title>{title}</Title>
            </Col>
          </Row>

          <Row>
            <Col
              xsOrder={1}
              sm={3}
              smOffset={1}
            >
              <Text dangerouslySetInnerHTML={{ __html: firstColumn }} />
            </Col>
            
            <Col
              xsOrder={3}
              sm={4}
            >
              <Image src={image.sourceUrl} />
            </Col>
            
            <Col
              xsOrder={2}
              sm={3}
            >
              <Text dangerouslySetInnerHTML={{ __html: secondColumn }} />

              {(iosLink || androidLink) && (
                <DownloadLinks>
                  {iosLink && (
                    <a href={iosLink} target="_blank">
                      <img src="/images/app-download-ios.png" alt="Download for iOS" />
                    </a>
                  )}
  
                  {androidLink && (
                    <a href={androidLink} target="_blank">
                      <img src="/images/app-download-android.png" alt="Download for iOS" />
                    </a>
                  )}
                </DownloadLinks>
              )}
            </Col>
          </Row>
        </Container>
        <Background />
      </Wrapper>
    )
  }
}

// Styles
const Wrapper = styled.section`
  margin-bottom: 65px;
  position: relative;

  ${media.xs`
    background: ${props => props.theme.colors.tones.lightest};
  `}
`

const Background = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: ${props => props.theme.colors.tones.lightest};
  border-right: 20px solid white;
  border-left: 20px solid white;

  ${media.xs`
    display: none;
  `}
`

const Title = styled.h2`
  font-size: 50px;
  line-height: 52px;
  font-weight: 300;
  text-align: center;

  ${media.xs`
    font-size: 30px;
    line-height: normal;
  `}
`

const Text = styled.div`
  margin-top: 8em;
  font-weight: 300;

  b, strong {
    font-weight: 500;
  }

  ${media.xs`
    margin-top: 2em;
  `}
`

const Image = styled.img`
  margin-top: 3em;
  width: 100%;

  ${media.xs`
    margin-top: 2em;
  `}
`

const DownloadLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 2em;

  img {
    margin-bottom: 0.5em;
    margin-right: 10px;
  }
`



// WEBPACK FOOTER //
// ./src/ui/components/modules/AppShowcase/index.js